export class FetchTokenError extends Error {
  error: Error | unknown;

  constructor(message: string, error?: Error | unknown) {
    super(message);
    this.name = 'FetchTokenError';
    this.error = error;
  }
}

export class LocalDBInitError extends Error {
  error: Error | unknown;

  constructor(message: string, error?: Error | unknown) {
    super(message);
    this.name = 'LocalDBInitError';
    this.error = error;
  }
}

export class NetworkConnectivityError extends Error {
  error: Error | unknown;

  constructor(message: string, error?: Error | unknown) {
    super(message);
    this.name = 'NetworkConnectivityError';
    this.error = error;
  }
}
